import React from "react";
import { NavLink } from "react-router-dom";

function TopBanner(props) {
  return (
    <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
      <div className="container-fluid pt-2 py-2">
        <a className="navbar-brand d-flex flex-column align-items-start" href="/" style={{ lineHeight: 1 }}>
          <img
            src="/westrow_logo.png"
            height="44"
            alt="Westrow Food Group"
            style={{ maxWidth: 160 }}
          />
          <span className="d-flex align-items-center gap-1 mt-1" style={{ fontSize: "0.6rem", color: "rgba(255,255,255,0.55)", letterSpacing: "0.03em" }}>
            powered by
            <img src="/markit_logo.png" height="14" alt="MarkIT" style={{ opacity: 0.75 }} />
            <span style={{ fontWeight: 600 }}>MarkIT</span>
          </span>
        </a>

        <ul className="nav">
          {props.items.map((item) => (
            <li key={item.href} className="nav-item">
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  isActive
                    ? "nav-link text-white top-nav-active"
                    : "nav-link text-white top-nav-link"
                }
              >
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default TopBanner;
